import trace from '~/lib/trace';
import {useContext, useRef, useCallback} from 'react';
import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';

import SessionStateContext from '../components/context/SessionStateContext';
import DispatchContext from '../components/context/DispatchContext';

export const useSelector = (selector) => {
  const sessionState = useContext(SessionStateContext);
  return selector(sessionState);
};

let dispatchFunc = noop;
const createDispatchFunc = (dispatch) => {
  if (dispatch && dispatchFunc === noop) {
    dispatchFunc = (action) => {
      if (isFunction(action)) {
        const exec = async () => {
          await action(dispatch);
        };

        return exec().catch(trace);
      } else {
        dispatch(action);
      }
    };
  }

  return dispatchFunc;
};

export const useDispatch = () => {
  const dispatch = useContext(DispatchContext);
  return createDispatchFunc(dispatch);
};

export const useThrottledCallback = (callback, deps) => {
  const pending = useRef(false);

  return useCallback(async (...args) => {
    if (pending.current) {
      return;
    }

    pending.current = true;
    try {
      return await callback(...args);
    } finally {
      pending.current = false;
    }
  }, deps);
};
